import { CommonModule } from '@angular/common';
import { Component, Inject, Injectable, OnInit } from '@angular/core';
import { CoreModule } from '@core/core.module';
import {
	MatterPackageHistoryEntry,
	PackageHistoryAction,
} from '@models/matter-package';
import { MatterPackageHistoryService } from '@services/matter-package-history.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

@Injectable({
	providedIn: 'root',
})
@Component({
	selector: 'app-matter-package-history',
	templateUrl: './matter-package-history.component.html',
	imports: [CommonModule, CoreModule],
})
export class MatterPackageHistoryComponent implements OnInit {
	PACKAGE_ACTIONS = PackageHistoryAction;

	constructor(
		private matterPackageHistoryService: MatterPackageHistoryService,
		@Inject(DRAWER_DATA) private data: { packageId: string },
	) {}
	packageHistoryEntries$: Observable<MatterPackageHistoryEntry[]>;

	ngOnInit() {
		this.packageHistoryEntries$ = this.matterPackageHistoryService
			.getHistoryForPackage(this.data.packageId)
			.pipe(map((entries) => entries.reverse()));
	}

	isToday(date: string | Date): boolean {
		const today = new Date();
		const checkDate = new Date(date);
		return (
			today.getDate() === checkDate.getDate() &&
			today.getMonth() === checkDate.getMonth() &&
			today.getFullYear() === checkDate.getFullYear()
		);
	}
}
